import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div>
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-deep-blue">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-deep-blue to-black opacity-70"></div>
          {/* This would be replaced with an actual image in production */}
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581092335397-9583eb92d232?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl font-montserrat">
            ABOUT PROTEC SERVICES & DISTRIBUTION
          </h1>
          <p className="mt-6 text-xl text-white max-w-3xl font-roboto">
            Your Trusted Partner in Automotive Electronics Solutions
          </p>
        </div>
      </div>
      
      {/* Company Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-deep-blue font-montserrat">OUR COMPANY</h2>
          </div>
          
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-2/3 lg:pr-12 mb-8 lg:mb-0">
              <p className="text-lg text-charcoal mb-6">
                Protec Services and Distribution is a leading provider of automotive electronics assembly and distribution services. We specialize in the assembly of automotive monitors and interior electronics parts, delivering precision and quality for the automotive industry.
              </p>
              <p className="text-lg text-charcoal mb-6">
                Founded with a commitment to excellence, our company has grown to become a trusted partner for automotive manufacturers and suppliers worldwide. Our state-of-the-art facilities and expert team ensure that every component we assemble meets the highest standards of quality and reliability.
              </p>
              <p className="text-lg text-charcoal">
                With a global distribution network, we ensure that our products reach clients efficiently and on time, supporting the automotive supply chain with dependable service and superior products.
              </p>
            </div>
            <div className="lg:w-1/3">
              {/* This would be replaced with an actual image in production */}
              <div className="bg-light-gray h-80 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1581092160607-ee22731c9c8c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Our Approach */}
      <section className="py-16 bg-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-deep-blue font-montserrat">OUR APPROACH</h2>
            <p className="mt-4 text-lg text-charcoal max-w-3xl mx-auto">
              We combine technical expertise with customer-focused service
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-deep-blue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Quality Focus</h3>
              <p className="text-charcoal">We maintain rigorous quality control standards throughout our assembly and distribution processes.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-deep-blue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Technical Expertise</h3>
              <p className="text-charcoal">Our team brings specialized knowledge in automotive electronics assembly and testing.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-deep-blue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Efficient Processes</h3>
              <p className="text-charcoal">Streamlined operations ensure timely delivery without compromising on quality.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="text-deep-blue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Customer-Centric</h3>
              <p className="text-charcoal">We prioritize client needs and build long-term relationships based on trust and reliability.</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Industry Experience */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-deep-blue font-montserrat">INDUSTRY EXPERIENCE</h2>
            <p className="mt-4 text-lg text-charcoal max-w-3xl mx-auto">
              Trusted expertise in automotive electronics
            </p>
          </div>
          
          <div className="prose prose-lg max-w-none text-charcoal">
            <p>
              With years of experience in the automotive industry, Protec Services and Distribution has developed specialized knowledge in the assembly and distribution of automotive monitors and interior electronics components. Our expertise spans across various types of automotive electronic systems, ensuring that we can meet the diverse needs of our clients.
            </p>
            <p>
              We work with leading automotive manufacturers and suppliers, providing them with high-quality components that meet strict industry standards. Our understanding of the automotive supply chain and the specific requirements of electronic components in vehicles allows us to deliver products that perform reliably in demanding automotive environments.
            </p>
            <p>
              Our commitment to staying at the forefront of automotive electronics technology ensures that we can provide cutting-edge solutions that help our clients maintain their competitive edge in a rapidly evolving industry.
            </p>
          </div>
        </div>
      </section>
      
      {/* Call to Action */}
      <section className="py-16 bg-deep-blue text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold font-montserrat mb-4">READY TO LEARN MORE?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Discover how our services can benefit your business
          </p>
          <a
            href="/contact"
            className="inline-block bg-light-blue hover:bg-blue-700 text-white font-montserrat font-semibold uppercase tracking-wider py-3 px-8 border border-transparent rounded-md shadow-md transition duration-300"
          >
            CONTACT US
          </a>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AboutPage;
